import styled from '@emotion/styled';

export const ImageContainer = styled.div`
  height: 122px;
  width: 150px;
  border-radius: 50%;
  margin-right: 1.5625rem;
  overflow: hidden;
`;
